import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./registrationfrom.css";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import UploadImgIcon from "../../Assets/Images/EployeeRegistration/icon-image.png";
import PreviewModal from "./PreviewModel";
import CropperModal from "./Cropper";
import Swal from "sweetalert2";
import SearchDropdown from "../OTC/dropdownInput";
import { FULL_API_BASE_URL } from "../../Config/Config";
import { fetchGenderData } from "../../Redux/EmployeeRegistration/genderSlice";
import { fetchCategorynData } from "../../Redux/EmployeeRegistration/categorySlice";
import { fetchSubCategorynData } from "../../Redux/StudentRegistration/subcategorySlice";
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import { fetchCoachingData } from "../../Redux/StudentRegistration/coachingSlice";
import { fetchStateData } from "../../Redux/StudentRegistration/stateSlice";
import { fetchClassTypeData } from "../../Redux/StudentRegistration/classTypeSlice";
import { fetchSchoolNameData } from "../../Redux/StudentRegistration/schoolSlice";
import { fetchClassData } from "../../Redux/StudentRegistration/classSlice";
import { fetchMediumData } from "../../Redux/StudentRegistration/mediumSlice";
import { fetchBoardData } from "../../Redux/StudentRegistration/boardSlice";
import SchoolSearch from "./SchoolSearch";
import EndPoints from "../../Api/EndPoints";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";
import WarningIcon from "../../Assets/Images/CommanImages/Warning.png";
import { useNavigate } from "react-router-dom";

function StudentRegistrationForm({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setMessageBoxHeight,
  setActiveImg,
  setNoTimeSet,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { statedata, loading, error } = useSelector((state) => state.domstate);
  const { subcategorydata } = useSelector((state) => state.subcategoies);
  const { genderdata } = useSelector((state) => state.gender);
  const { categorydata } = useSelector((state) => state.categories);
  const { coursesdata } = useSelector((state) => state.course);
  const { coachingData } = useSelector((state) => state.coaching);
  const { classtypedata } = useSelector((state) => state.classType);
  const { schoolnamedata } = useSelector((state) => state.schoolname);
  const { classData } = useSelector((state) => state.classname);
  const { mediumData } = useSelector((state) => state.medium);
  const { boardData } = useSelector((state) => state.board);
  const [customFields, setCustomFields] = useState({
    custom_field_1: "",
    custom_field_2: "",
    custom_field_3: "",
    custom_field_4: "",
    custom_field_5: "",
    custom_field_6: "",
  });
  const [isCustomOpen, setIsCustomOpen] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedGenderName, setSelectedGenderName] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedSubCategoryName, setSelectedSubCategoryName] = useState("");
  const [selectedCoachingName, setSelectedCoachingName] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedMediumName, setSelectedMediumName] = useState("");
  const [selectedIncomeName, setSelectedIncomeName] = useState("");
  const [selectedFatherIncomeName, setSelectedFatherIncomeName] = useState("");
  const [selectedLocalCityName, setSelectedLocalCityName] = useState("");
  const [selectedPermCityName, setSelectedPermCityName] = useState("");
  const [selectedPreviousCoachingName, setSelectedPreviousCoachingName] =
    useState("");
  const [rollNumberErrors, setRollNumberErrors] = useState([]);

  // Form state
  const [address, setAddress] = useState({});
  const [educationDetails, setEducationDetails] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isEduOpen, setIsEduOpen] = useState(false);
  const [selectedSchoolName, setSelectedSchoolName] = useState("");
  const [isAddressOpen, setIsAddressOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCity, setFilteredCity] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const searchContainerRef = useRef(null);
  const [searchPermCity, setSearchPermCity] = useState("");
  const [filteredPermCity, setFilteredPermCity] = useState([]);
  const searchPermCityRef = useRef(null);
  const [sameAsLocal, setSameAsLocal] = useState(false);
  const [localCityOptions, setLocalCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [stateName, setStateName] = useState("");
  const [permCityOptions, setPermCityOptions] = useState([]);
  const [selectedPermCity, setSelectedPermCity] = useState(null);
  const [stateNamePerm, setStateNamePerm] = useState("");
  const [isGuardianOpen, setIsGuardianOpen] = useState(false);
  const [gaurdianInfo, setGaurdianInfo] = useState({
    fathers_name: "",
    fathers_occupation: "",
    fathers_designation: "",
    fathers_annual_income: "",
    fathers_email_id: "",
    fathers_mob_no: "",
    mothers_name: "",
    mothers_occupation: "",
    mothers_designation: "",
    mothers_annual_income: "",
    mothers_email_id: "",
    mothers_mob_no: "",
    guardian_name: "",
    guardian_mob_no: "",
    guardian_relation: null,
    comments_: "",
  });
  // Personal Info state
  const [personalInfo, setPersonalInfo] = useState({
    enquiry_id: null,
    roll_number: "",
    class_type_id: null,
    student_first_name: "",
    student_middle_name: "",
    student_last_name: "",
    date_of_birth: "",
    gender_id: 0,
    aadhaar_no: "",
    category_id: null,
    sub_category_id: null,
    domicile_city_id: 0,
    student_mob_no: "",
    email_id: "",
    emrgency_contact_mob_no: "",
    course_id: null,
    last_coaching_id: null,
    delete_flag: 0,
    photograph: "",
  });

  // Image handling state
  const [croppedImageBlob, setCroppedImageBlob] = useState(null);
  const [image, setImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [fileName, setFileName] = useState("No selected file");
  const [src, setSrc] = useState(null);
  const cropperRef = useRef(null);

  // UI state
  const [isOpen, setIsOpen] = useState(true);
  const [rollNumberMessage, setRollNumberMessage] = useState("");

  // Client data
  const client_id = dataClient?.client_schema_name[6][0].client_id;
  const user_name = dataClient?.client_schema_name[6][0].user_name;
  const client_branch_id =
    dataClient?.client_schema_name[6][0].client_branch_id;

  // Fetch data on mount
  useEffect(() => {
    dispatch(fetchGenderData());
    dispatch(fetchCategorynData());
    dispatch(fetchSubCategorynData());
    dispatch(fetchCourseData());
    dispatch(fetchCoachingData());
    dispatch(fetchStateData());
    dispatch(fetchClassTypeData());
    dispatch(fetchSchoolNameData());
    dispatch(fetchClassData());
    dispatch(fetchMediumData());
    dispatch(fetchBoardData());
  }, [dispatch]);

  // Track unsaved changes
  // useEffect(() => {
  //   const hasChanges =
  //     personalInfo.roll_number !== "" ||
  //     personalInfo.student_first_name !== "" ||
  //     personalInfo.student_mob_no !== "" ||
  //     Object.keys(address).length > 0 ||
  //     Object.keys(educationDetails).length > 0 ||
  //     Object.keys(gaurdianInfo).length > 0 ||
  //     croppedImageBlob !== null;
  //   Object.values(customFields).some(val => val !== "");

  //   setHasUnsavedChanges(hasChanges);
  // }, [personalInfo, address, educationDetails, gaurdianInfo, croppedImageBlob, customFields]);

  // Track unsaved changes
  useEffect(() => {
    const hasChanges =
      personalInfo.roll_number !== "" ||
      personalInfo.student_first_name !== "" ||
      personalInfo.student_mob_no !== "" ||
      Object.keys(address).length > 0 ||
      Object.keys(educationDetails).length > 0 ||
      // ✅ Fix: Check actual guardian field values, not just key count
      Object.values(gaurdianInfo).some((val) => val !== "" && val !== null) ||
      croppedImageBlob !== null ||
      // ✅ Fix: This was a dangling statement before, now properly OR'd in
      Object.values(customFields).some((val) => val !== "");

    setHasUnsavedChanges(hasChanges);
  }, [
    personalInfo,
    address,
    educationDetails,
    gaurdianInfo,
    croppedImageBlob,
    customFields,
  ]);

  // Update personalInfo with image when cropped
  useEffect(() => {
    if (croppedImageBlob) {
      setPersonalInfo((prev) => ({
        ...prev,
        IMG: croppedImageBlob,
      }));
      console.log("Sending image:", {
        imageSize: croppedImageBlob.size,
        imageType: croppedImageBlob.type,
        imageName: croppedImageBlob.name,
      });
    }
  }, [croppedImageBlob]);

  const onChange = (event) => {
    const { name, value } = event.target;

    setPersonalInfo((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "roll_number") {
      const inputElement = event.target;

      const handleBlur = () => {
        if (!value.trim()) return;

        fetch(`${FULL_API_BASE_URL}/check_roll_no/?roll_no=${value.trim()}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {
              setMessageBox(
                <div className="Container-messageBOX">
                  <div className="messagebox-insider1">
                    <div className="loader-tc success"></div>
                    <span>{data.message}</span>
                  </div>
                </div>
              );
              setIsMessageBoxVisible(true);
              setActiveImg(WarningIcon);
            }
          })
          .catch((error) => {
            console.error("Error checking roll number:", error);

            setMessageBox(
              <div className="Container-messageBOX">
                <div className="messagebox-insider1">
                  <div className="loader-tc error"></div>
                  <span>Error checking roll number. Please try again.</span>
                </div>
              </div>
            );
            setIsMessageBoxVisible(true);
            setActiveImg(WarningIcon);
          })
          .finally(() => {
            inputElement.removeEventListener("blur", handleBlur);
          });
      };

      inputElement.addEventListener("blur", handleBlur);
    }
  };

  // const handleRollNumberBlur = (e) => {
  //   const rollNumber = e.target.value.trim();
  //   if (!rollNumber) return;

  //   fetch(
  //     `${FULL_API_BASE_URL}/check_roll_no/?roll_no=${rollNumber}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status === 200) {
  //         setMessageBox(
  //           <div className="Container-messageBOX">
  //             <div className="messagebox-insider1">
  //               <div className="loader-tc success"></div>
  //               <span>{data.message}</span>
  //             </div>
  //           </div>
  //         );
  //         setIsMessageBoxVisible(true);
  //         setActiveImg(WarningIcon);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error checking roll number:", error);

  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc error"></div>
  //             <span>Error checking roll number. Please try again.</span>
  //           </div>
  //         </div>
  //       );
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(WarningIcon);
  //     });
  // };

  // Handle state selection

  const handleRollNumberBlur = async (e) => {
    const rollNumber = e.target.value.trim();

    // Clear previous errors
    setRollNumberErrors([]);

    // If empty, don't check - let validateFormWithErrors handle it
    if (!rollNumber) {
      return;
    }

    try {
      const result = await checkDuplicateRollNumber(rollNumber);
      console.log("Duplicate check result:", result);

      if (result.isDuplicate) {
        // Set error state
        const newErrors = [
          "This roll number is already registered, please use a different roll number",
        ];
        setRollNumberErrors(newErrors);

        // Show error message
        showErrorMessage(newErrors);
      } else {
        // Roll number is valid
        setRollNumberErrors([]);
      }
    } catch (error) {
      console.error("Validation error:", error);
    }
  };

  const handleStateSelect = (selectedOption) => {
    setPersonalInfo((prevValues) => ({
      ...prevValues,
      domicile_city_id: selectedOption ? selectedOption.state_id : null,
    }));
  };

  // Image handling functions
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result);
        setImage(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCroppedImage = (croppedFile) => {
    setCroppedImageBlob(croppedFile);
    setImage(URL.createObjectURL(croppedFile));
    setPersonalInfo((prev) => ({
      ...prev,
      photograph: croppedFile,
      IMG: croppedFile,
    }));
    setShowCropper(false);
    setSrc(null);
  };

  const handleDeleteImage = () => {
    setImage(null);
    setSrc(null);
    setFileName("No selected file");
    setCroppedImageBlob(null);
    setPersonalInfo((prev) => ({
      ...prev,
      photograph: null,
      IMG: null,
    }));
    setShowCropper(false);
  };

  const handleCropComplete = async () => {
    if (!cropperRef.current) return;

    try {
      const dataUrl = cropperRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();

      const timestamp = new Date().getTime();
      const filename = `profile_${timestamp}.jpg`;

      const file = new File([blob], filename, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });

      handleCroppedImage(file);
    } catch (err) {
      console.error("Image processing error:", err);
      showErrorMessage(["Error processing image. Please try again."]);
    }
  };

  const showErrorMessage = (errors) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span style={{ whiteSpace: "pre-line" }}>
            {errors.length === 1 ? errors[0] : errors.join("\n")}
          </span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
    setMessageBoxHeight("auto");
    setActiveImg(ErrorImg);
  };

  const showSuccessMessage = (message) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc success"></div>
          <span>{message}</span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
    setHasUnsavedChanges("10vh");
    setActiveImg(InterogativeImg);
  };

  const checkDuplicateRollNumber = async (rollNumber) => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/check_roll_no/?roll_no=${rollNumber.trim()}`
      );

      const data = await response.json();
      console.log("API Response:", data, "Status:", response.status);

      if (data.status === 200) {
        return {
          isDuplicate: true,
          message: data.message || "This roll number already exists",
        };
      }

      return {
        isDuplicate: false,
        message: "Roll number is available",
      };
    } catch (error) {
      console.error("Error checking roll number:", error);
      return {
        isDuplicate: false,
        message: "Could not validate",
      };
    }
  };

  const validateFormWithErrors = async () => {
    const errors = [];
    if (!personalInfo.roll_number) {
      errors.push("Student Roll Number is required");
    } else {
      // If roll number exists, check if it's duplicate
      try {
        const rollNumberCheck = await checkDuplicateRollNumber(
          personalInfo.roll_number
        );

        if (rollNumberCheck.isDuplicate) {
          errors.push(
            "This roll number is already registered, please use a different roll number"
          );
        }
      } catch (error) {
        console.error("Error checking roll number:", error);
        errors.push("Error validating roll number. Please try again.");
      }
    }

    if (!personalInfo.class_type_id) {
      errors.push("Class Type is required");
    }
    if (!personalInfo.student_first_name) {
      errors.push("First Name is required");
    }
    if (!personalInfo.date_of_birth) {
      errors.push("Date of Birth is required");
    }
    if (!personalInfo.gender_id || personalInfo.gender_id === 0) {
      errors.push("Gender is required");
    }
    if (!personalInfo.category_id) {
      errors.push("Category is required");
    }
    if (!personalInfo.sub_category_id) {
      errors.push("Sub Category is required");
    }
    if (!personalInfo.student_mob_no) {
      errors.push("Mobile Number is required");
    }
    if (!personalInfo.emrgency_contact_mob_no) {
      errors.push("Emergency Contact Number is required");
    }
    if (!personalInfo.course_id) {
      errors.push("Course is required");
    }
    if (!educationDetails.current_class_id) {
      errors.push("Current Class is required");
    }
    if (!educationDetails.education_medium_id) {
      errors.push("Education Medium is required");
    }
    if (!address.loc_add1) {
      errors.push("Local Address is required");
    }
    if (!address.loc_city_id) {
      errors.push("Local City is required");
    }
    if (!address.perm_add1) {
      errors.push("Permanent Address is required");
    }
    if (!address.perm_city_id) {
      errors.push("Permanent City is required");
    }

    const hasFatherInfo =
      gaurdianInfo.fathers_name && gaurdianInfo.fathers_mob_no;
    const hasMotherInfo =
      gaurdianInfo.mothers_name && gaurdianInfo.mothers_mob_no;

    if (!hasFatherInfo && !hasMotherInfo) {
      errors.push("Please provide either father's or mother's information");
    }

    return errors;
  };

  const clearFormData = () => {
    setPersonalInfo({
      enquiry_id: null,
      roll_number: "",
      class_type_id: null,
      student_first_name: "",
      student_middle_name: "",
      student_last_name: "",
      date_of_birth: "",
      gender_id: 0,
      aadhaar_no: "",
      category_id: null,
      sub_category_id: null,
      domicile_city_id: 0,
      student_mob_no: "",
      email_id: "",
      emrgency_contact_mob_no: "",
      course_id: null,
      last_coaching_id: null,
      delete_flag: 0,
      photograph: "",
    });
    setEducationDetails({});
    setAddress({});
    setGaurdianInfo({});
    setCustomFields({
      custom_field_1: "",
      custom_field_2: "",
      custom_field_3: "",
      custom_field_4: "",
      custom_field_5: "",
      custom_field_6: "",
    });
    setImage(null);
    setCroppedImageBlob(null);
    setHasUnsavedChanges(false);
  };

  const handleSubmit = async () => {
    const errors = await validateFormWithErrors();
    if (errors.length > 0) {
      setShowValidationErrors(true);
      showErrorMessage(errors);
      return;
    }
    setShowValidationErrors(false);
    setShowPreviewModal(true);
  };

  useEffect(() => {
    if (showValidationErrors) {
      const errors = validateFormWithErrors();
      if (errors.length === 0) {
        setShowValidationErrors(false);
      }
    }
  }, [
    personalInfo,
    address,
    educationDetails,
    gaurdianInfo,
    showValidationErrors,
  ]);

  const handleConfirmSubmit = async () => {
    try {
      const formData = new FormData();
      const studentData = {
        ...personalInfo,
        ...educationDetails,
        ...address,
        ...gaurdianInfo,
        ...customFields,
        enquiry_id: personalInfo.enquiry_id || null,
        emergency_contact_name: "Not Available",
        status: 1,
        last_modified_date: new Date().toISOString(),
        last_modified_by: user_name,
        create_date: new Date().toISOString(),
        created_by: user_name,
        client_branch_id: client_branch_id,
        client_id: client_id,
        delete_flag: 0,

        // Board/class fields
        board_id_5: educationDetails.board_id_5 || null,
        pass_year_5: educationDetails.pass_year_5 || "",
        school_name_5: educationDetails.school_name_5 || "",
        percentage_cgpa_5: educationDetails.percentage_cgpa_5 || "",

        board_id_6: educationDetails.board_id_6 || null,
        pass_year_6: educationDetails.pass_year_6 || "",
        school_name_6: educationDetails.school_name_6 || "",
        percentage_cgpa_6: educationDetails.percentage_cgpa_6 || "",

        board_id_7: educationDetails.board_id_7 || null,
        pass_year_7: educationDetails.pass_year_7 || "",
        school_name_7: educationDetails.school_name_7 || "",
        percentage_cgpa_7: educationDetails.percentage_cgpa_7 || "",

        board_id_8: educationDetails.board_id_8 || null,
        pass_year_8: educationDetails.pass_year_8 || "",
        school_name_8: educationDetails.school_name_8 || "",
        percentage_cgpa_8: educationDetails.percentage_cgpa_8 || "",

        board_id_9: educationDetails.board_id_9 || null,
        pass_year_9: educationDetails.pass_year_9 || "",
        school_name_9: educationDetails.school_name_9 || "",
        percentage_cgpa_9: educationDetails.percentage_cgpa_9 || "",

        board_id_10: educationDetails.board_id_10 || null,
        pass_year_10: educationDetails.pass_year_10 || "",
        school_name_10: educationDetails.school_name_10 || "",
        percentage_cgpa_10: educationDetails.percentage_cgpa_10 || "",

        board_id_11: educationDetails.board_id_11 || null,
        pass_year_11: educationDetails.pass_year_11 || "",
        school_name_11: educationDetails.school_name_11 || "",
        percentage_cgpa_11: educationDetails.percentage_cgpa_11 || "",

        board_id_12: educationDetails.board_id_12 || null,
        pass_year_12: educationDetails.pass_year_12 || "",
        school_name_12: educationDetails.school_name_12 || "",
        percentage_cgpa_12: educationDetails.percentage_cgpa_12 || "",

        guardian_name: gaurdianInfo.guardian_name || "",
        guardian_mob_no: gaurdianInfo.guardian_mob_no || "",
        guardian_relation: gaurdianInfo.guardian_relation || null,
        comments_: gaurdianInfo.comments_ || "",
      };

      // Handle image
      if (personalInfo.IMG) {
        const photograph = personalInfo.IMG;
        const { IMG, ...dataWithoutImage } = studentData;
        formData.append("photograph", photograph);
        formData.append("student_data", JSON.stringify(dataWithoutImage));
      } else {
        formData.append("student_data", JSON.stringify(studentData));
      }

      // Make API call
      const response = await fetch(`${EndPoints.NEW_STUDENT_REGISTRATION}`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.detail || errorData.message || "Failed to submit form"
        );
      }

      const responseData = await response.json();

      // Close modal FIRST
      setShowPreviewModal(false);

      // Then show success/error
      if (responseData.result === "success") {
        showSuccessMessage(
          responseData.message || "Student registered successfully"
        );
        clearFormData();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        showErrorMessage([responseData.message || "Registration failed"]);
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setShowPreviewModal(false);
      showErrorMessage([error.message || "Error submitting form"]);
    }
  };

  const onCustomFieldChange = (e) => {
    const { name, value } = e.target;
    setCustomFields({ ...customFields, [name]: value });
  };

  const toggleCustomAccordion = () => {
    setIsCustomOpen(!isCustomOpen);
  };

  const handleCancel = () => {
    if (hasUnsavedChanges) {
      if (setMessageBox && setIsMessageBoxVisible) {
        if (setMessageBoxHeight) {
          setMessageBoxHeight("10vh");
        }

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>You have unsaved changes. Do you want to continue?</span>
            </div>
            <div
              className="messagebox-insider2"
              style={{ display: "flex", gap: "10px", marginTop: "10px" }}
            >
              <button
                className="messagebox-cancel-btn-ok"
                // onClick={() => {
                //   clearFormData();
                //   setIsMessageBoxVisible(false);
                //   setTimeout(() => {
                //     window.location.reload();
                //   }, 100);
                // }}
                onClick={() => {
                  clearFormData();
                  setIsMessageBoxVisible(false);
                  navigate("/studentdashboard"); // 👈 replace with your actual route path
                }}
              >
                YES
              </button>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  setIsMessageBoxVisible(false);
                }}
              >
                NO
              </button>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(WarningIcon);
      }
    } else {
      // window.location.reload();
      navigate("/studentdashboard");
    }
  };

  const handleSchoolSelect = (school) => {
    setEducationDetails((prevInfo) => ({
      ...prevInfo,
      last_school_id: school.school_id,
    }));
    setSelectedSchoolName(school.school_name);
  };

  const handleEducationChange = (e) => {
    const { name, value } = e.target;
    setEducationDetails((prevInfo) => ({ ...prevInfo, [name]: value }));
  };

  const toggleEducationAccordion = () => {
    setIsEduOpen(!isEduOpen);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (event) => {
    setSameAsLocal(event.target.checked);
    if (event.target.checked) {
      setAddress((prev) => ({
        ...prev,
        perm_add1: prev.loc_add1,
        perm_add2: prev.loc_add2,
        perm_pincode: prev.loc_pincode,
        perm_city_id: prev.loc_city_id,
      }));
      setSearchPermCity(searchTerm);
      setStateNamePerm(stateName);
      setSelectedPermCity(selectedCity);
    } else {
      setAddress((prev) => ({
        ...prev,
        perm_add1: "",
        perm_add2: "",
        perm_pincode: "",
        perm_city_id: "",
      }));
      setSearchPermCity("");
      setStateNamePerm("");
      setSelectedPermCity(null);
    }
  };

  const handleItemClickOne = (item) => {
    setSelectedCity(item);
    setSearchTerm(item.city_name);
    setStateName(item.state_name);
    setFilteredCity([]);
    setActiveIndex(-1);
    setAddress((prev) => ({
      ...prev,
      loc_city_id: item.city_id,
    }));
  };

  const toggleAddressAccordion = () => {
    setIsAddressOpen(!isAddressOpen);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setActiveIndex(-1);
    if (value.trim() === "") {
      setFilteredCity([]);
      setSelectedCity(null);
      setStateName("");
    } else if (value.length >= 2) {
      handleSearchClick();
    }
  };

  const handleSearchClick = () => {
    if (searchTerm.trim() === "" || searchTerm.length < 2) {
      setFilteredCity([]);
      return;
    }
    setSearchTerm((prevSearchTerm) => {
      fetch(
        `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
          prevSearchTerm
        )}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const filtered = data.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(prevSearchTerm.toLowerCase())
            )
          );
          setFilteredCity(filtered);
          setActiveIndex(filtered.length > 0 ? 0 : -1);
        })
        .catch((error) => {
          console.error("Error fetching city list:", error);
        });
      return prevSearchTerm;
    });
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setFilteredCity([]);
    }
  };

  const fetchLocalCityOptions = (inputText) => {
    if (inputText.trim().length < 2) {
      setLocalCityOptions([]);
      return;
    }
    fetch(
      `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
        inputText
      )}`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setLocalCityOptions(data);
      })
      .catch((error) => {
        console.error("Error fetching local city list:", error);
      });
  };

  const fetchPermCityOptions = (inputText) => {
    if (inputText.trim().length < 2) {
      setPermCityOptions([]);
      return;
    }
    fetch(
      `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
        inputText
      )}`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setPermCityOptions(data);
      })
      .catch((error) => {
        console.error("Error fetching permanent city list:", error);
      });
  };

  const handleClickOutsidePerm = (event) => {
    if (
      searchPermCityRef.current &&
      !searchPermCityRef.current.contains(event.target)
    ) {
      setFilteredPermCity([]);
    }
  };

  // ADD THESE useEffect HOOKS after existing useEffect hooks
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidePerm);
    return () => {
      document.removeEventListener("click", handleClickOutsidePerm);
    };
  }, []);

  const handleGuardianChange = (e) => {
    const { name, value } = e.target;
    setGaurdianInfo((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // ADD THIS TOGGLE FUNCTION
  const toggleGuardianAccordion = () => {
    setIsGuardianOpen(!isGuardianOpen);
  };

  // ADD THIS FUNCTION for dropdown handling
  const handleGuardianDropdownChange = (fieldName, selectedOption) => {
    setGaurdianInfo((prevValues) => ({
      ...prevValues,
      [fieldName]: selectedOption,
    }));
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Student Registration</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSubmit}>
            SAVE
          </button>
        </div>
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>PERSONAL INFORMATION</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen &&
          classtypedata &&
          statedata &&
          coachingData &&
          coursesdata &&
          categorydata &&
          genderdata &&
          subcategorydata && (
            <div className="accordion-content">
              <div className="grid-container">
                <div className="item1">
                  <FormInputs
                    label="Enquiry Number"
                    type="text"
                    name="enquiry_id"
                    value={personalInfo.enquiry_id}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[0-9]{1,50}"
                    disabled
                    bg="#d6d6d6"
                  />
                </div>
                <div className="item2" style={{ position: "relative" }}>
                  <FormInputs
                    label="Student Roll Number"
                    type="text"
                    name="roll_number"
                    value={personalInfo.roll_number}
                    onChange={onChange}
                    onBlur={handleRollNumberBlur}
                    maxLength={10}
                    pattern="[A-Za-z,0-9]{1,50}"
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="item3">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Class Type"
                      setSelected={(selectedOption) =>
                        setPersonalInfo({
                          ...personalInfo,
                          class_type_id: selectedOption,
                        })
                      }
                      options={[
                        { label: "Online", id: 1 },
                        { label: "Classroom", id: 2 },
                      ]}
                      isRequired={true}
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
                <div className="item4">
                  <FormInputs
                    label="First Name"
                    type="text"
                    name="student_first_name"
                    value={personalInfo.student_first_name}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="item5">
                  <FormInputs
                    label="Middle Name"
                    type="text"
                    name="student_middle_name"
                    value={personalInfo.student_middle_name}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                    showError={showValidationErrors}
                  />
                </div>
                <div className="item6">
                  <FormInputs
                    label="Last Name"
                    type="text"
                    name="student_last_name"
                    value={personalInfo.student_last_name}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                  />
                </div>
                <div className="item7">
                  <FormInputs
                    label="Date of Birth"
                    type="date"
                    name="date_of_birth"
                    value={personalInfo.date_of_birth}
                    onChange={onChange}
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="item8">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Gender"
                      // setSelected={(selectedOption) =>
                      //   setPersonalInfo({ ...personalInfo, gender_id: selectedOption })
                      // }
                      setSelected={(selectedOption) => {
                        const gender = genderdata.find(
                          (g) => g.gender_id === selectedOption
                        );
                        setSelectedGenderName(gender?.gender_name || "");
                        setPersonalInfo({
                          ...personalInfo,
                          gender_id: selectedOption,
                        });
                      }}
                      options={genderdata.map((gender) => ({
                        label: gender.gender_name,
                        id: gender.gender_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
                <div className="item9">
                  <FormInputs
                    label="Aadhar Number"
                    type="text"
                    name="aadhaar_no"
                    value={personalInfo.aadhaar_no}
                    onChange={onChange}
                    pattern="[0-9]{12}"
                    maxLength={12}
                  />
                </div>
                <div className="item10">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Category"
                      // setSelected={(selectedOption) =>
                      //   setPersonalInfo({ ...personalInfo, category_id: selectedOption })
                      // }
                      setSelected={(selectedOption) => {
                        const category = categorydata.find(
                          (c) => c.category_id === selectedOption
                        );
                        setSelectedCategoryName(category?.category_desc || "");
                        setPersonalInfo({
                          ...personalInfo,
                          category_id: selectedOption,
                        });
                      }}
                      options={categorydata.map((cat) => ({
                        label: cat.category_desc,
                        id: cat.category_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
                <div className="item11">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Sub Category"
                      // setSelected={(selectedOption) =>
                      //   setPersonalInfo({ ...personalInfo, sub_category_id: selectedOption })
                      // }
                      setSelected={(selectedOption) => {
                        const subCategory = subcategorydata.find(
                          (s) => s.sub_category_id === selectedOption
                        );
                        setSelectedSubCategoryName(
                          subCategory?.sub_category_desc || ""
                        );
                        setPersonalInfo({
                          ...personalInfo,
                          sub_category_id: selectedOption,
                        });
                      }}
                      options={subcategorydata.map((subcat) => ({
                        label: subcat.sub_category_desc,
                        id: subcat.sub_category_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
                <div
                  className="item12"
                  style={{
                    gridRowStart: "4",
                    gridRowEnd: "8",
                    gridColumnStart: "3",
                    gridColumnEnd: "3",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <label>Photograph</label>
                    <div className="input-image">
                      <div className="input-image-field">
                        <input
                          type="file"
                          accept="image/*"
                          name="photograph"
                          className="input-field"
                          hidden
                          onChange={handleImageChange}
                        />
                        {!showCropper ? (
                          <>
                            {image ? (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  overflow: "hidden",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                }}
                              >
                                <img
                                  className="uploaded-img"
                                  src={image}
                                  alt={fileName}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="icon-img-container">
                                <img
                                  src={UploadImgIcon}
                                  alt="upload icon"
                                  className="icon-img"
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "300px",
                            }}
                          >
                            <CropperModal src={src} cropperRef={cropperRef} />
                          </div>
                        )}
                      </div>
                      <div className="image-btns-container">
                        {showCropper ? (
                          <>
                            <div
                              className="replace-image-btn"
                              style={{ marginBottom: "10px" }}
                              onClick={handleCropComplete}
                            >
                              Save Changes
                            </div>
                            <div
                              className="replace-image-btn"
                              onClick={() =>
                                document.querySelector(".input-field").click()
                              }
                            >
                              Replace
                            </div>
                            <div
                              className="del-image-btn"
                              onClick={handleDeleteImage}
                            >
                              Delete
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className="replace-image-btn"
                              onClick={() =>
                                document.querySelector(".input-field").click()
                              }
                            >
                              {image ? "Replace" : "Upload"}
                            </div>
                            {image && (
                              <div
                                className="del-image-btn"
                                onClick={handleDeleteImage}
                              >
                                Delete
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item13">
                  <div className="selecte-dropdown-items">
                    <div>
                      {loading ? (
                        <p>Loading states...</p>
                      ) : error ? (
                        <p>Error loading states: {error}</p>
                      ) : (
                        <SearchDropdown
                          initialOptions={statedata || []}
                          onSelect={handleStateSelect}
                          placeholder="Type to search..."
                          label="Domicile State"
                          labelKey={(option) => option.state_name}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="item14">
                  <FormInputs
                    label="Mobile Number"
                    type="text"
                    name="student_mob_no"
                    value={personalInfo.student_mob_no}
                    onChange={onChange}
                    pattern="[0-9]{10,11}"
                    maxLength={10}
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="item15">
                  <FormInputs
                    label="Student Email ID"
                    type="email"
                    name="email_id"
                    value={personalInfo.email_id}
                    onChange={onChange}
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{{2,}}"
                  />
                </div>
                <div className="item16">
                  <FormInputs
                    label="Emergency Contact Number"
                    type="text"
                    name="emrgency_contact_mob_no"
                    value={personalInfo.emrgency_contact_mob_no}
                    onChange={onChange}
                    pattern="[0-9]{10,11}"
                    maxLength={10}
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="item17">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Course"
                      setSelected={(selectedOption) => {
                        // Find the course object to get the name
                        const course = coursesdata.find(
                          (c) => c.course_id === selectedOption
                        );
                        setSelectedCourseName(course?.course_description || "");
                        setPersonalInfo({
                          ...personalInfo,
                          course_id: selectedOption,
                        });
                      }}
                      options={coursesdata.map((course) => ({
                        label: course.course_description,
                        id: course.course_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
                <div className="item12">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Previous coaching"
                      // setSelected={(selectedOption) =>
                      //   setPersonalInfo({ ...personalInfo, last_coaching_id: selectedOption })
                      // }
                      setSelected={(selectedOption) => {
                        const coaching = coachingData.find(
                          (c) => c.institute_id === selectedOption
                        );
                        setSelectedPreviousCoachingName(
                          coaching?.institute_name || ""
                        );
                        setSelectedCoachingName(coaching?.institute_name || "");
                        setPersonalInfo({
                          ...personalInfo,
                          last_coaching_id: selectedOption,
                        });
                      }}
                      options={coachingData.map((coach) => ({
                        label: coach.institute_name,
                        id: coach.institute_id,
                      }))}
                      Height="auto"
                      OverFlow="auto"
                      minheight="300px"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>EDUCATION DETAIL</label>
          </div>
          <div className="accordion-btn" onClick={toggleEducationAccordion}>
            {isEduOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isEduOpen &&
          schoolnamedata &&
          classData &&
          mediumData &&
          boardData && (
            <div className="accordion-content">
              <div className="grid-container-education">
                <div className="selecte-dropdown-items">
                  <SchoolSearch
                    onSchoolSelect={handleSchoolSelect}
                    showError={showValidationErrors}
                    isRequired={true}
                  />
                </div>
                <div className="grid-item">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Class"
                      // setSelected={(selectedOption) =>
                      //   setEducationDetails((prevInfo) => ({
                      //     ...prevInfo,
                      //     current_class_id: selectedOption,
                      //   }))
                      // }
                      setSelected={(selectedOption) => {
                        const classItem = classData.find(
                          (cls) => cls.class_id === selectedOption
                        );
                        setSelectedClassName(classItem?.class_name || "");
                        setEducationDetails((prevInfo) => ({
                          ...prevInfo,
                          current_class_id: selectedOption,
                        }));
                      }}
                      options={classData.map((cls) => ({
                        label: cls.class_name,
                        id: cls.class_id,
                      }))}
                      isRequired={true}
                      placeholder="Enter class"
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
                <div className="grid-item">
                  <div className="selecte-dropdown-items">
                    <DropDown
                      label="Medium of education"
                      // setSelected={(selectedOption) =>
                      //   setEducationDetails((prevInfo) => ({
                      //     ...prevInfo,
                      //     education_medium_id: selectedOption,
                      //   }))
                      // }
                      setSelected={(selectedOption) => {
                        const medium = mediumData.find(
                          (med) => med.medium_id === selectedOption
                        );
                        setSelectedMediumName(medium?.medium_desc || "");
                        setEducationDetails((prevInfo) => ({
                          ...prevInfo,
                          education_medium_id: selectedOption,
                        }));
                      }}
                      options={mediumData.map((med) => ({
                        label: med.medium_desc,
                        id: med.medium_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                    />
                  </div>
                </div>
              </div>
              <span className="academic-recod-title">Academic record:</span>
              <div className="academic-recode-container">
                <div className="academic-tile">CLASS</div>
                <div className="academic-tile">BOARD</div>
                <div className="academic-tile">YEAR</div>
                <div className="academic-tile">SCHOOL NAME</div>
                <div className="academic-tile">%</div>

                {[5, 6, 7, 8, 9, 10, 11, 12].map((classNum) => (
                  <React.Fragment key={classNum}>
                    <div className="class-name">
                      {classNum === 5
                        ? "V"
                        : classNum === 6
                        ? "VI"
                        : classNum === 7
                        ? "VII"
                        : classNum === 8
                        ? "VIII"
                        : classNum === 9
                        ? "IX"
                        : classNum === 10
                        ? "X"
                        : classNum === 11
                        ? "XI"
                        : "XII"}
                    </div>
                    <div className="data">
                      <div className="selecte-dropdown-items">
                        <DropDown
                          setSelected={(selectedOption) =>
                            setEducationDetails((prevInfo) => ({
                              ...prevInfo,
                              [`board_id_${classNum}`]: selectedOption,
                            }))
                          }
                          options={boardData.map((bod) => ({
                            label: bod.edu_board_name,
                            id: bod.edu_board_id,
                          }))}
                        />
                      </div>
                    </div>
                    <div className="data">
                      <FormInputs
                        type="text"
                        name={`pass_year_${classNum}`}
                        value={educationDetails[`pass_year_${classNum}`] || ""}
                        onChange={handleEducationChange}
                        maxLength={4}
                      />
                    </div>
                    <div className="data">
                      <FormInputs
                        type="text"
                        name={`school_name_${classNum}`}
                        value={
                          educationDetails[`school_name_${classNum}`] || ""
                        }
                        onChange={handleEducationChange}
                        pattern="[A-Za-z, ]{1,50}"
                      />
                    </div>
                    <div className="data">
                      <FormInputs
                        type="text"
                        name={`percentage_cgpa_${classNum}`}
                        value={
                          educationDetails[`percentage_cgpa_${classNum}`] || ""
                        }
                        onChange={handleEducationChange}
                        maxLength={2}
                        pattern="[0-9]{1,50}"
                      />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>ADDRESSES</label>
          </div>
          <div className="accordion-btn" onClick={toggleAddressAccordion}>
            {isAddressOpen ? (
              <div className="minus" />
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isAddressOpen && (
          <div className="accordion-content">
            <div className="address-info">
              <div>
                <FormInputs
                  label="Local Address"
                  type="text"
                  name="loc_add1"
                  value={address.loc_add1 || ""}
                  onChange={handleAddressChange}
                  placeholder="Address line 1"
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  required
                  showError={showValidationErrors}
                />
              </div>
              <div>
                <FormInputs
                  type="text"
                  name="loc_add2"
                  value={address.loc_add2 || ""}
                  onChange={handleAddressChange}
                  placeholder="Address line 2"
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                />
              </div>
              <div className="grid-container-address">
                <div className="selecte-dropdown-items">
                  <SearchDropdown
                    initialOptions={localCityOptions}
                    onInputChange={fetchLocalCityOptions}
                    onSelect={(option) => {
                      if (option) {
                        setSelectedCity(option);
                        setStateName(option.state_name);
                        setSelectedLocalCityName(option.city_name);
                        setAddress((prev) => ({
                          ...prev,
                          loc_city_id: option.city_id,
                        }));
                      } else {
                        setSelectedCity(null);
                        setStateName("");
                        setAddress((prev) => ({
                          ...prev,
                          loc_city_id: 0,
                        }));
                      }
                    }}
                    placeholder="Search..."
                    label="City/District"
                    labelKey={(option) => option.city_name}
                    required={true}
                    showError={showValidationErrors}
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="State"
                    type="text"
                    value={stateName}
                    disabled={selectedCity !== null}
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="Pin Code"
                    type="text"
                    name="loc_pincode"
                    value={address.loc_pincode || ""}
                    onChange={handleAddressChange}
                    maxLength={6}
                    pattern="[0-9]{6}"
                  />
                </div>
              </div>
              <div
                className="parmanent-add-checkbox"
                style={{ marginTop: "30px" }}
              >
                <div style={{ position: "relative" }}>
                  <div className="local-add-checkbox">
                    <label>Same as Local Address</label>
                    <input
                      type="checkbox"
                      checked={sameAsLocal}
                      onChange={handleCheckboxChange}
                      className="cr-custom-checkbox"
                    />
                  </div>
                  <FormInputs
                    label="Permanent Address"
                    type="text"
                    name="perm_add1"
                    value={address.perm_add1 || ""}
                    onChange={handleAddressChange}
                    placeholder="Address line 1"
                    disabled={sameAsLocal}
                    maxlength="200"
                    pattern="[A-Za-z0-9-, ]{1,200}"
                    required
                    showError={showValidationErrors}
                  />
                  <FormInputs
                    type="text"
                    name="perm_add2"
                    value={address.perm_add2 || ""}
                    onChange={handleAddressChange}
                    placeholder="Address line 2"
                    maxlength="200"
                    pattern="[A-Za-z0-9-, ]{1,200}"
                    disabled={sameAsLocal}
                  />
                </div>
                <div className="grid-container-address">
                  <div className="selecte-dropdown-items">
                    <SearchDropdown
                      initialOptions={permCityOptions}
                      selected={selectedPermCity}
                      onInputChange={fetchPermCityOptions}
                      onSelect={(option) => {
                        if (option) {
                          setSelectedPermCity(option);
                          setStateNamePerm(option.state_name);
                          setSelectedPermCityName(option.city_name);
                          setAddress((prev) => ({
                            ...prev,
                            perm_city_id: option.city_id,
                          }));
                        } else {
                          setSelectedPermCity(null);
                          setStateNamePerm("");
                          setAddress((prev) => ({
                            ...prev,
                            perm_city_id: 0,
                          }));
                        }
                      }}
                      placeholder="Search..."
                      label="City/District"
                      labelKey={(option) => option.city_name}
                      required={true}
                      showError={showValidationErrors}
                      disabled={sameAsLocal}
                    />
                  </div>
                  <div className="grid-item">
                    <FormInputs
                      label="State"
                      type="text"
                      value={stateNamePerm}
                      // disabled={selectedPermCity !== null}
                      disabled={selectedPermCity !== null || sameAsLocal}
                      required
                      showError={showValidationErrors}
                    />
                  </div>
                  <div className="grid-item">
                    <FormInputs
                      label="Pin Code"
                      type="text"
                      name="perm_pincode"
                      value={address.perm_pincode || ""}
                      onChange={handleAddressChange}
                      maxLength={6}
                      pattern="[0-9]{6}"
                      disabled={sameAsLocal}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>GUARDIAN INFORMATION</label>
          </div>
          <div className="accordion-btn" onClick={toggleGuardianAccordion}>
            {isGuardianOpen ? (
              <div className="minus" />
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isGuardianOpen && (
          <div className="accordion-content">
            <div className="grid-container">
              <div className="grid-item">
                <FormInputs
                  label="Father's Name"
                  type="text"
                  name="fathers_name"
                  value={gaurdianInfo.fathers_name}
                  onChange={handleGuardianChange}
                  maxlength={200}
                  pattern="[A-Za-z ]{1,150}"
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Occupation"
                  type="text"
                  name="fathers_occupation"
                  value={gaurdianInfo.fathers_occupation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Designation"
                  type="text"
                  name="fathers_designation"
                  value={gaurdianInfo.fathers_designation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                />
              </div>
              <div className="grid-item">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Annual Income"
                    setSelected={(selectedOption) => {
                      const incomeOption = [
                        { label: "0 To Rs 2,00,000", id: "1" },
                        { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                        { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                        { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                        { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                        { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                        { label: "> Rs 15,00,000", id: "7" },
                        { label: "Not Available", id: "8" },
                      ].find((income) => income.id === selectedOption);

                      setSelectedFatherIncomeName(incomeOption?.label || "");
                      handleGuardianDropdownChange(
                        "fathers_annual_income",
                        selectedOption
                      );
                    }}
                    options={[
                      { label: "0 To Rs 2,00,000", id: "1" },
                      { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                      { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                      { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                      { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                      { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                      { label: "> Rs 15,00,000", id: "7" },
                      { label: "Not Available", id: "8" },
                    ]}
                  />
                </div>
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Email ID"
                  type="email"
                  name="fathers_email_id"
                  value={gaurdianInfo.fathers_email_id}
                  onChange={handleGuardianChange}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Mobile Number"
                  type="text"
                  name="fathers_mob_no"
                  value={gaurdianInfo.fathers_mob_no}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
              <div className="grid-item" style={{ marginTop: "40px" }}>
                <FormInputs
                  label="Mother's Name"
                  type="text"
                  name="mothers_name"
                  value={gaurdianInfo.mothers_name}
                  onChange={handleGuardianChange}
                  maxlength={200}
                  pattern="[A-Za-z ]{1,50}"
                />
              </div>
              <div className="grid-item" style={{ marginTop: "40px" }}>
                <FormInputs
                  label="Occupation"
                  type="text"
                  name="mothers_occupation"
                  value={gaurdianInfo.mothers_occupation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                />
              </div>
              <div className="grid-item" style={{ marginTop: "40px" }}>
                <FormInputs
                  label="Designation"
                  type="text"
                  name="mothers_designation"
                  value={gaurdianInfo.mothers_designation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                />
              </div>
              <div className="grid-item">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Annual Income"
                    setSelected={(selectedOption) => {
                      const incomeOption = [
                        { label: "0 To Rs 2,00,000", id: "1" },
                        { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                        { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                        { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                        { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                        { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                        { label: "> Rs 15,00,000", id: "7" },
                        { label: "Not Available", id: "8" },
                      ].find((income) => income.id === selectedOption);

                      setSelectedIncomeName(incomeOption?.label || "");
                      handleGuardianDropdownChange(
                        "mothers_annual_income",
                        selectedOption
                      );
                    }}
                    options={[
                      { label: "0 To Rs 2,00,000", id: "1" },
                      { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                      { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                      { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                      { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                      { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                      { label: "> Rs 15,00,000", id: "7" },
                      { label: "Not Available", id: "8" },
                    ]}
                  />
                </div>
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Email ID"
                  type="email"
                  name="mothers_email_id"
                  value={gaurdianInfo.mothers_email_id}
                  onChange={handleGuardianChange}
                  maxlength={150}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Mobile Number"
                  type="text"
                  name="mothers_mob_no"
                  value={gaurdianInfo.mothers_mob_no}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Guardian Name"
                  type="text"
                  name="guardian_name"
                  value={gaurdianInfo.guardian_name}
                  onChange={handleGuardianChange}
                  maxlength={200}
                  pattern="[A-Za-z, ]{1,50}"
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Guardian's Mobile Number"
                  type="text"
                  name="guardian_mob_no"
                  value={gaurdianInfo.guardian_mob_no}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Guardian's Relation"
                  type="text"
                  name="guardian_relation"
                  value={gaurdianInfo.guardian_relation || ""}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{0,4}"
                  maxLength={4}
                />
              </div>
              <div className="comments">
                <label>Comments</label>
                <textarea
                  name="comments_"
                  value={gaurdianInfo.comments_}
                  onChange={handleGuardianChange}
                  placeholder="Write your comment here..."
                  maxLength={500}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>CUSTOM FIELDS</label>
          </div>
          <div className="accordion-btn" onClick={toggleCustomAccordion}>
            {isCustomOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isCustomOpen && (
          <div className="accordion-content">
            <div className="grid-container">
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 1"
                  type="text"
                  name="custom_field_1"
                  value={customFields.custom_field_1}
                  onChange={onCustomFieldChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 2"
                  type="text"
                  name="custom_field_2"
                  value={customFields.custom_field_2}
                  onChange={onCustomFieldChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 3"
                  type="text"
                  name="custom_field_3"
                  value={customFields.custom_field_3}
                  onChange={onCustomFieldChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 4"
                  type="text"
                  name="custom_field_4"
                  value={customFields.custom_field_4}
                  onChange={onCustomFieldChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 5"
                  type="text"
                  name="custom_field_5"
                  value={customFields.custom_field_5}
                  onChange={onCustomFieldChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 6"
                  type="text"
                  name="custom_field_6"
                  value={customFields.custom_field_6}
                  onChange={onCustomFieldChange}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <PreviewModal
        isOpen={showPreviewModal}
        onClose={() => setShowPreviewModal(false)}
        data={{
          personalInfo,
          educationDetails,
          address,
          gaurdianInfo,
          customFields,
          imagePreview: image,
          courseName: selectedCourseName,
          genderName: selectedGenderName,
          categoryName: selectedCategoryName,
          subCategoryName: selectedSubCategoryName,
          coachingName: selectedCoachingName,
          className: selectedClassName,
          mediumName: selectedMediumName,
          selectedIncomeName: selectedIncomeName,
          selectedFatherIncomeName: selectedFatherIncomeName,
          localCityName: selectedLocalCityName,
          permCityName: selectedPermCityName,
          previousCoachingName: selectedPreviousCoachingName,
        }}
        onConfirm={handleConfirmSubmit}
      />
    </div>
  );
}

export default StudentRegistrationForm;

// const handleSubmit = () => {
//   // Validate form
//   const errors = validateFormWithErrors();
//   if (errors.length > 0) {
//     setShowValidationErrors(true); // Enable error display
//     showErrorMessage(errors);
//     return;
//   }

//   // Just show the preview modal - NO SUBMISSION YET
//   setShowValidationErrors(false); // Clear errors if validation passes
//   setShowPreviewModal(true);
// };

// const validateFormWithErrors = () => {
//   const errors = [];

//   if (!personalInfo.roll_number) {
//     errors.push("Student Roll Number is required");
//   }
//   if (!personalInfo.class_type_id) {
//     errors.push("Class Type is required");
//   }
//   if (!personalInfo.student_first_name) {
//     errors.push("First Name is required");
//   }
//   if (!personalInfo.date_of_birth) {
//     errors.push("Date of Birth is required");
//   }
//   if (!personalInfo.gender_id || personalInfo.gender_id === 0) {
//     errors.push("Gender is required");
//   }
//   if (!personalInfo.student_mob_no) {
//     errors.push("Mobile Number is required");
//   }
//   if (!personalInfo.emrgency_contact_mob_no) {
//     errors.push("Emergency Contact Number is required");
//   }
//   if (!personalInfo.course_id) {
//     errors.push("Course is required");
//   }
//   if (!educationDetails.current_class_id) {
//     errors.push("Current Class is required");
//   }
//   if (!educationDetails.education_medium_id) {
//     errors.push("Education Medium is required");
//   }
//   if (!address.loc_add1) {
//     errors.push("Local Address is required");
//   }
//   if (!address.loc_city_id) {
//     errors.push("Local City is required");
//   }
//   if (!address.perm_add1) {
//     errors.push("Permanent Address is required");
//   }
//   if (!address.perm_city_id) {
//     errors.push("Permanent City is required");
//   }

//   // Guardian validation
//   const hasFatherInfo = gaurdianInfo.fathers_name && gaurdianInfo.fathers_mob_no;
//   const hasMotherInfo = gaurdianInfo.mothers_name && gaurdianInfo.mothers_mob_no;

//   if (!hasFatherInfo && !hasMotherInfo) {
//     errors.push("Please provide either father's or mother's information");
//   }

//   return errors;
// };
